<nav>
  <ul class="breadcrumb">
    <li class="breadcrumb-item wizard">Pre-Log Entry</li>
    <li class="breadcrumb-item wizard"><i class="fa fa-chevron-right"></i>Review Entry</li>
    <li class="breadcrumb-item wizard"><i class="fa fa-chevron-right"></i>Ready to Send Sample</li>
    <li class="ms-auto"><a routerLink="/sample-search"><i class="fa fa-search" style="width: 20px;"></i>Sample Search</a></li>
    <li class="ms-3">@if (externalLinks) {
      <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
    }</li>
  </ul>
</nav>
<div class="text-center">
  <h1>Ready to Send Sample</h1>
</div>
<div class="col-12">
  <p style="font-size: 1.2rem">The DNA Sample using Kit Barcode # {{ preLog.kitBarcode }} has been pre-logged.</p>
  <p style="font-size: 1.2rem">Thank you for using the DNA Sample Pre-Log website!</p>
  <p>Please mail the collected DNA sample along with the completed submission form to:</p>
  <div class="ms-5">
    {{ contactInfo.lab }}<br />
    {{ contactInfo.section }}<br />
    {{ contactInfo.addressLine1 }}<br />
    {{ contactInfo.addressLine2 }}
  </div>
  <p class="mt-3" style="font-size: 1.2rem"><strong>NOTE:</strong> For pre-logged submissions, you only need to fill out the backside (SIDE B - see image below) of the submission form and collect thumbprints.</p>
  <p>View <a [routerLink]="['/pre-log', preLog.id]">submission details</a> for a printable copy of your submission.</p>
  <img class="submission-form" alt="Submission Form Side B" src="/assets/Submission Form Side B.jpg" />
</div>
<ng-template #arresteeReminder let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Arrestee Reminder</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <div class="modal-body">
    <p style="font-size: 1.2rem">Don't forget to enclose a copy of the arrest warrant.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" ngbAutoFocus (click)="modal.dismiss()">OK</button>
  </div>
</ng-template>
<ng-template #pleaAgreementReminder let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Plea Agreement Reminder</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <div class="modal-body">
    <p style="font-size: 1.2rem">Don't forget to enclose a copy of the plea agreement/circuit court order.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" ngbAutoFocus (click)="modal.dismiss()">OK</button>
  </div>
</ng-template>
